if (!customElements.get('bundle-variants')) {
  class ProductBundleVariants extends HTMLElement {
    constructor() {
      super();

      this.initVariants();

    }

    initVariants() {
      if (location.search.indexOf('?variant=') > -1) {
        let variantId = location.search.split('?variant=')[1];
        if (document.querySelector('[data-bundle-variant-data]')) {
          if (document.querySelector('[data-bundle-variant-data]').dataset) {
            let variantData = JSON.parse(document.querySelector('[data-bundle-variant-data]').dataset.bundleVariantData);
            let variantsToSelect = variantData[variantId];
            if (variantsToSelect) {
              document.querySelector('[data-bundle-variant-data]').querySelectorAll('.border-black').forEach((input) => {
                input.classList.remove('border-black');
                input.classList.add('border-black-50');
              })
              let variantsToSelectArr = variantsToSelect.split(',');
              variantsToSelectArr.forEach((variantToSelect, index) => {
                let elementArr = document.querySelector('[data-bundle-variant-data]').querySelectorAll('[data-bundle-variant-id="' + variantToSelect + '"]');
                let selectIndex = 0;
                if (elementArr.length > 1) {
                  selectIndex = index;
                }
                let element = elementArr[selectIndex];
                element.classList.remove('border-black-50');
                element.classList.add('border-black');
                setTimeout(function(){
                  element.click();
                }, 250);
              });
            }
          }
        }
      }

      // Bind option select events
      this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
        variant.addEventListener('click', this.onBundleVariantSelect.bind(this));
      });
    }

    /**
     * onBundleVariantSelect
     * @description Toggles variant switch for bundles
     */
    onBundleVariantSelect(event) {

      let target = event.target;
      if (typeof target.src === 'undefined') {
        if (event.target.querySelector('img')) {
          target = event.target.querySelector('img');
        } else {
          target = event.target.closest('[data-bundle-variant]').querySelector('img');
        }
      }

      let group = target.closest('[data-bundle-variant-group]');
      if (group.querySelector('.border-black')) {
        group.querySelector('.border-black').classList.add('border-black-50');
        group.querySelector('.border-black').classList.remove('border-black');
      }
      target.closest('[data-bundle-variant]').classList.remove('border-black-50');
      target.closest('[data-bundle-variant]').classList.add('border-black');
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = target.src;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = target.srcset;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = target.alt;
      this.switchVariant();
    }

    /**
     * switchVariant
     * @description Switches main variant to selected from bundles
     */
    switchVariant() {

      let variantsToSelect = [];
      let bundleGroupArr = this.querySelectorAll('[data-bundle-variant-group]');
      bundleGroupArr.forEach(function(bundleGroup, index){
        let variantsArr = bundleGroup.querySelectorAll('[data-bundle-variant]');
        variantsArr.forEach(function(variant){
          if (variant.classList.contains('border-black')) {
            variantsToSelect.push(variant.dataset.bundleVariantId);
          }
        });
      });
      let variantsSorted = variantsToSelect.sort().join(',');
      if (variantsToSelect !== '') {
        document.querySelector('[data-bundle-options="' + variantsSorted + '"] input').checked = true;
        var event = new Event('change');
        document.querySelector('variant-radios').dispatchEvent(event);
      }
    }

  }

  window.ProductBundleVariants = ProductBundleVariants;
  customElements.define('bundle-variants', ProductBundleVariants);
}
